import { Box, styled, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { immersightBlue } from '../../utils/colors';

interface TabConfig {
  id: string;
}

interface ImsTabsProps {
  tabs: TabConfig[];
  initialSelectedIndex?: number;
  onTabChange?: (selectedIndex: number) => void;
}

const StyledTabs = styled(Tabs)({
  '& .MuiTabs-indicator': {
    display: 'none', // Hide the default underline
  },
});

const StyledTab = styled(Tab, {
  shouldForwardProp: (prop) => prop !== 'first' && prop !== 'last',
})<{ first?: boolean; last?: boolean }>(({ first, last }) => ({
  flex: 1,
  minWidth: 0,
  maxWidth: 'none',
  padding: '10px 16px',
  margin: 0,
  textTransform: 'uppercase',
  fontWeight: 'bold',
  letterSpacing: '1px',
  fontSize: '12px',
  backgroundColor: '#e0e0e0',
  color: '#828282',
  minHeight: 'auto',
  '&.Mui-selected': {
    backgroundColor: immersightBlue,
    color: '#ffffff',
  },
  '&:hover': {
    backgroundColor: '#bdbdbd',
  },
  ...(first && {
    borderTopLeftRadius: '16px',
    borderBottomLeftRadius: '16px',
  }),
  ...(last && {
    borderTopRightRadius: '16px',
    borderBottomRightRadius: '16px',
  }),
}));


const ImsTabs: React.FC<ImsTabsProps> = ({
  tabs,
  initialSelectedIndex = 0,
  onTabChange,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(initialSelectedIndex);
  const intl = useIntl();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedIndex(newValue);
    onTabChange?.(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <StyledTabs
        value={selectedIndex}
        onChange={handleChange}
        variant="standard"
        sx={{ width: '100%' }}  // as wide as its content
        aria-label="imstabs"
      >
        {tabs.map((tab, index) => (
          <StyledTab
            key={tab.id}
            label={intl.formatMessage({ id: tab.id }).toUpperCase()}
            first={index === 0}
            last={index === tabs.length - 1}
          />
        ))}
      </StyledTabs>
    </Box>
  );
};

export default ImsTabs;
